<template>
  <QAutoComplete :value="value" :label="label ? label : $t('servicesystem.common_objects.user.type')"
    :placeholder="placeholder ? placeholder : $t('servicesystem.common_objects.user_types.search_field_label')"
    :disabled="disabled" :loading="loading" :list="listOfRoles" :textkey="'text'" :valuekey="'id'" :multiple="multiple"
    :clearable="clearable" :externaledit="externaledit" @input="e => $emit('input', e)" @FocusState="e => $emit('FocusState', e)">
    <template v-slot:prepend-outer>
      <UserTypeTextTemplate v-if="!multiple" :id="value" only-icon />
      <v-icon v-else size="18">mdi-account</v-icon>
    </template>
    <template v-slot:selection="{ item }">
      <UserTypeTextTemplate :id="item.id" :only-text="!multiple" />
    </template>
    <template v-slot:item="{ item }">
      <UserTypeTextTemplate :id="item.id" />
    </template>
  </QAutoComplete>
</template>


<script>
import UserTypeMixin from "@/helpers/Mixins/UserTypeMixin";
import rules from "@/helpers/Mixins/QInputRuleMixin.js";
import UserTypeTextTemplate from "@/components/UserTypeTextTemplate.vue";

export default {
  name: "UserTypeSelect",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    label: String,
    placeholder: String,
    value: [Object, String, Number, Array],
    clearable: Boolean,
    disabled: Boolean,
    loading: Boolean,
    externaledit: Boolean,
    multiple: Boolean,

    onlyCustomer: Boolean,
    onlyNonCustomer: Boolean,
  },
  components: {
    UserTypeTextTemplate,
  },
  mixins: [rules, UserTypeMixin],

  data() {
    return {
    };
  },

  mounted() { },

  methods: {},

  computed: {
    listOfRoles() {
      if (this.onlyCustomer) { return this.customerUserTypes; }
      else if (this.onlyNonCustomer) { return this.notCustomerUserTypes; }
      else { return this.sortedUserTypes; }
    },
  },

  watch: {},
};
</script>


<style lang="scss"></style>